// extracted by mini-css-extract-plugin
export default {"boxPadding":"albumHome_boxPadding__Rvpz2"};